import { BaseMainHeaderMenu } from './main-header-menu';
import { MenuItem } from './menu-item';
import { MenuMode } from './menu-mode.enum';
import { MenuStates } from './menu-states.enum';

export class DefaultMainHeaderMenu extends BaseMainHeaderMenu {
    constructor(state: MenuStates, opts: { title: string; items?: MenuItem[]; showSearch?: boolean }) {
        super(MenuMode.DEFAULT, state, opts);
    }
}
